import React from "react";
import { styled, TableCell, TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";

const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

const UsersTableRow = ({
  user,
}) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`${user.userEntityId}`);
  };

  return (
    <StyledTableRow onClick={handleRowClick}>
      <TableCell component="th" scope="row">
        {user.lastName}
      </TableCell>
      <TableCell align="right">{user.firstName}</TableCell>
      <TableCell align="right">{user.createDate}</TableCell>
      <TableCell align="right">{user.modifyDate}</TableCell>
    </StyledTableRow>
  );
};

export default UsersTableRow;